module.exports = __webpack_public_path__ + "img/confounded.17818c02.png";